module.exports = __webpack_public_path__ + "static/media/E5.da82a7a3.wav";